/**
 *
 * FIXME I have fine-tuned drawings.  So I'd better substitute magic numbers to global variables or sth.
 * The current normal sources are ReservePage.bak.33 and CanvasPage.bak.43.
 **/
import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from "react-redux";

import { useDrizzleContext } from "../drizzle/drizzleContext";

import * as ReserveActions from './actions';

import Canvas from './Canvas';
import TimeBar from './TimeBar';
import ConfirmAction from '../selected-actions/ConfirmAction';
import { Definition } from '../components/Definition';
import Box from '../components/Box';

import ReturnToday from '../icons/ReturnToday';
import LeftArrow from '../icons/LeftArrow';
import RightArrow from '../icons/RightArrow';

import '../css/Reserve.css';
import '../css/LdsDualRing.css';

// FIXME Should I write this component not as a function but as a class?  But hooks...
// Note that don't forget {} in () of the begining of functional components, otherwise React returns an object, not functions or variables.
const ReservePage = ({
  dispatch,
  accounts,
  accountBalances,
  pathnameAtSynced,
  previousPathname,
  type,
  added,
  synced,
  processing,
  confirmedQueue,
  navBarHeight,
  navBarWidth,
  show,
  cancel,
  reserve,
  reserveOfDays,
  targetDay,
  week,
  onClickChangeDay,
  onClickToday,
  onClickPrevious,
  onClickNext,
  jabraNumber,
  onClickEle,
  onClickDropdown,
  open
}) => {
  const pathname = useLocation().pathname;

  const drizzle = useDrizzleContext();
  const [ balanceInEth, setBalanceInEth ] = useState(null);

  useEffect(async () => {
    const _balance = drizzle.web3.utils.fromWei(await drizzle.web3.eth.getBalance(accounts[0]));
    setBalanceInEth(_balance);
  }, [synced]);

  var selectedTime = null;
  var selectedOffset = null;
  var selectedHeight = null;
  var jabraNumberInSolidity;
  var savedTime;
  var startTime;
  var endTime;

  const [ confirmAction, setConfirmAction ]= useState(null);

  const HALF_MINUTES = 60 / 2;
  const NUM_OF_DAYS = 7;
  const NUM_OF_MINUTES = 24 * 60 / 30; // 24 hours * 60 minuites / 30 minutes
  const NAVBAR = 950; // FIXME I should switch the width, based on the media query.
  const NAVBAR_WIDTH = 150;
  const TIMEBAR_WIDTH = 38.2; // 18 is the width of time characters, and the multication factor 3 is due to the right and left margin.
  const GOTO_HEIGHT = 112;
  const TODAY_WIDTH_SSMALL = 16;
  const TODAY_WIDTH_SMALL = 32;
  const TODAY_WIDTH_LARGE = 128;
  var day;
  var start;
  var end;
  const dayOfWeekString = [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ];
  const monthString = [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ];

  const [ dimention, setDimention ] = useState({
    fullWidth: window.innerWidth,
    fullHeight: window.innerHeight });

  const drawingRegion = {
    width: dimention.fullWidth,
    height: dimention.fullHeight*3.0 }

  const headerElm = useRef();
  const paddingLarge = 28.0;
  const paddingSmall = 14.0;
  const [ canvasTop, setCanvasTop ] = useState(null);
  const [ canvasLeft, setCanvasLeft ] = useState(null);

  useEffect(() => {
    if (headerElm.current !== null && drawingRegion.width > NAVBAR) {
      setCanvasTop(headerElm.current.getBoundingClientRect().height-paddingLarge);
      setCanvasLeft(headerElm.current.getBoundingClientRect().width);
    } else if (headerElm.current !== null && drawingRegion.width <= NAVBAR) {
      setCanvasTop(headerElm.current.getBoundingClientRect().height-paddingSmall);
      setCanvasLeft(headerElm.current.getBoundingClientRect().width);
    }
  }, [window.innerWidth, window.innerHeight]);

  const multiplication = 1.5;
  const contentsStyle = drawingRegion.width > NAVBAR
    ? { left: '50%', top: canvasTop, transform: 'translateX(-50%)', padding: paddingLarge, background: 'white' }
    : { padding: paddingSmall, top: navBarHeight+canvasTop, background: 'white' };

  const navBarVertHeight = drawingRegion.height + canvasTop*multiplication;

  useEffect(() => {
    dispatch(notifyReserveHeight(navBarVertHeight));
  }, [navBarVertHeight]);

  const todayIncrement = dimention.fullWidth > NAVBAR
    ? { width: (drawingRegion.width - (NAVBAR_WIDTH + TIMEBAR_WIDTH)) / (NUM_OF_DAYS + 1.2) + TODAY_WIDTH_LARGE,
        height: drawingRegion.height / NUM_OF_MINUTES }
    : dimention.fullWidth > 830
    ? { width: drawingRegion.width / (NUM_OF_DAYS + 1.2) + TODAY_WIDTH_SMALL,
        height: drawingRegion.height / NUM_OF_MINUTES }
    : { width: drawingRegion.width / (NUM_OF_DAYS + 3.0) + TODAY_WIDTH_SSMALL,
        height: drawingRegion.height / NUM_OF_MINUTES }

  const increment = dimention.fullWidth > NAVBAR
    ? { width: (drawingRegion.width - (NAVBAR_WIDTH + TIMEBAR_WIDTH)) / (NUM_OF_DAYS + 1.2) - TODAY_WIDTH_LARGE/6,
        height: drawingRegion.height / NUM_OF_MINUTES }
    : dimention.fullWidth > 830
    ? { width: drawingRegion.width / (NUM_OF_DAYS + 1.2) - TODAY_WIDTH_SMALL/6,
        height: drawingRegion.height / NUM_OF_MINUTES }
    : { width: drawingRegion.width / (NUM_OF_DAYS + 3.0) - TODAY_WIDTH_SMALL/6,
        height: drawingRegion.height / NUM_OF_MINUTES }

  const calenderElm = useRef(null);
  const [ calenderWidth, setCalenderWidth ] = useState(null);

  useEffect(() => {
    if (calenderElm.current !== null) {
      setCalenderWidth(calenderElm.current.getBoundingClientRect().width);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (pathname === pathnameAtSynced) {
      dispatch(notifyAfterSync());
      return;
    }

    if ((previousPathname === null && processing === -1)
      || (pathname !== previousPathname)) {
      const heightFinetune = 32;
      const fixedPosition = calenderElm.current.getBoundingClientRect().height * 1/3 - heightFinetune;

      window.scrollTo(0, fixedPosition);
    }
  }, [pathname])

  const headerStyle = dimention.fullWidth > NAVBAR
    ? { background: 'white' }
    : { top: navBarHeight, left: '50%', transform: 'translate(-50%, 0%)', background: 'white' }

  const CANVAS_HEADER = increment.height * 2;
  const minutesStyles = { width: increment.width, height: drawingRegion.height, background: '#ffffff' };
  const todayMinutesStyles = { width: todayIncrement.width, height: drawingRegion.height, background: '#ffffff' };

  //const JABRA_NUMBER_MAX = 256; // FIXME We might need to implement the scrollbar to display all elements of the list.
  const JABRA_NUMBER_MAX = 2;
  const jabraNumberList = [];
  for(var i=0; i<JABRA_NUMBER_MAX; i++) jabraNumberList.push(i);

  var daysOfWeek = [];
  var calenderHeader = [];

  const [ current, setCurrent ] = useState({});
  const [ previous, setPrevious ] = useState({
      previousDay: null,
      previousOffset: null,
      previousHeight: null,
      previousClearRectangle: null
  });

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    //document.addEventListener("mousedown", this.handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      //document.addEventListener("mousedown", this.handleClickOutside);
    }
  }, []);

  const clearPreviousRectangle = (day, offset, height, contained, resizable, confirming, clearRectangle) => {
    setCurrent({
      day: day,
      offset: offset,
      height: height,
      contained: contained,
      resizable: resizable,
      confirming: confirming,
      clearRectangle: clearRectangle
    });
  }

  useEffect(() => {
    if (Object.keys(current).length === 0)
      return;

    if (previous.previousDay !== null && previous.previousDay !== current.day) {
      previous.previousClearRectangle(previous.previousOffset, previous.previousHeight+1, current.day, current.confirming);
    } else if ((previous.previousDay === current.day
      && current.contained !== true
      && previous.previousHeight === 0
      && previous.previousOffset !== current.offset)
      || (previous.previousDay === current.day
        && current.contained !== true
        && current.resizable !== true)) {
      previous.previousClearRectangle(current.offset, current.height, current.day, current.confirming);
    }

    setPrevious({
      previousDay: current.day,
      previousOffset: current.offset,
      previousHeight: current.height,
      previousClearRectangle: current.clearRectangle
    });
  }, [current]);

  useEffect(() => {
    if (!added)
      return;

    closeBar();
  }, [added]);

  const selectedMenu = (_date, _offset, _height, selectedReserved, confirming) => {
    selectedTime = new Date(_date);
    selectedOffset = _offset;
    selectedHeight = _height;

    var startDate = null;
    var startString = "";
    var endDate = null;
    var endString = "";

    var reserving = false;
    var canceling = false;

    if (confirming) {
      closeBar();
      return null;
    } else if (Object.keys(selectedReserved).length === 0) {
      jabraNumberInSolidity = jabraNumber - 1;
      savedTime = new Date(selectedTime);
      startTime = calculateStart(selectedTime, selectedOffset);
      selectedTime = savedTime;
      endTime = calculateEnd(selectedTime, selectedOffset, selectedHeight);

      startDate = new Date(startTime);
      startString = makeTimeString(startDate);
      endDate = new Date(endTime);
      endString = makeTimeString(endDate);
      reserving = true;
    } else if (selectedReserved.owner === accounts[0]) {
      jabraNumberInSolidity = jabraNumber - 1;
      startTime = selectedReserved.startTime * 1000; // Note that we don't need to multiply this by 1000.  But normalize this variable.
      startDate = new Date(startTime);
      startString = makeTimeString(startDate);
      endTime = selectedReserved.endTime * 1000;
      endDate = new Date(endTime);
      endString = makeTimeString(endDate);
      canceling = true;
    } else {
      closeBar();
      return null;
    }

    const innerWidthEm = window.innerWidth / parseFloat(getComputedStyle(document.querySelector('body'))['font-size']);

    // FIXME I don't want to set this value to state.
    setConfirmAction(
      <ConfirmAction
        className={'fixed bottom-0 right-0'}
        style={{
          maxWidth: innerWidthEm < 60 ? '100%' : 'calc(100% - 156px)',
          zIndex: 32
        }}
        confirm={confirmReservation}
        cancel={confirmCancel}
        close={closeBar}
        jabraNumber={jabraNumber}
        startString={startString}
        endString={endString}
        reserving={reserving}
        canceling={canceling}
        animateOnStart />
    );
  }

  const makeTimeString = (_date) => {
    return (
      monthString[_date.getMonth()]
      + " " + _date.getDate()
      + " " + _date.getHours()
      + ":" + ('0' + _date.getMinutes()).slice(-2)
      + ", " + _date.getFullYear()
    );
  }

  const closeBar = () => {
    setConfirmAction(null);
  }

  const confirmReservation = () => {
    reserve(jabraNumberInSolidity, startTime, endTime);
  }

  const confirmCancel = () => {
    cancel(jabraNumberInSolidity, startTime, endTime);
  }


  const calculateStart = (date, offset) => {
    return date.setMinutes(date.getMinutes() + offset*HALF_MINUTES);
  }

  const calculateEnd = (date, offset, height) => {
    return date.setMinutes(date.getMinutes() + (offset+height+1)*HALF_MINUTES); // Note that height begins at 0.
  }

  const handleResize = () => {
    setDimention({
      fullWidth: window.innerWidth,
      fullHeight: window.innerHeight
    });
  }

  const startOfWeek = day => {
    var year = day.getFullYear();
    var month = day.getMonth();
    var date = day.getDate();
    var dayNum = day.getDay();
    var sunday = date - dayNum;
    var curDay = new Date(year, month, sunday);

    return monthString[curDay.getMonth()] + " " + curDay.getDate() + ", " + curDay.getFullYear();
  }

  const endOfWeek = day => {
    var year = day.getFullYear();
    var month = day.getMonth();
    var date = day.getDate();
    var dayNum = day.getDay();
    var sunday = date - dayNum;
    var curDay = new Date(year, month, sunday);

    curDay.setDate(curDay.getDate() + NUM_OF_DAYS - 1);
    return monthString[curDay.getMonth()] + " " + curDay.getDate();
  }

  // FIXME I would have to add Jabra number to redraw the respective calender with respect to Jabra number.
  start = startOfWeek(targetDay);
  end = endOfWeek(targetDay);
  //const [ week, setWeek ] = useState(makeDaysOfWeek(targetDay));

  var dropDownList = [];

  dropDownList = jabraNumberList.map(i => {
    return (<li key={i} onClick={() => onClickEle(i+1)}><span>{i+1}</span></li>);
  });

  for (day = 0; day < NUM_OF_DAYS; day++) {
    const headerClass = day !== NUM_OF_DAYS - 1 ? 'normal-pos' : 'most-right';

    if (day === targetDay.getDay()) {
      calenderHeader[day] =
        <div key={day} className={headerClass}
          style={{ height: CANVAS_HEADER, width: todayIncrement.width, borderTop: '5px solid #4499AA' }}>
          <div className='flex pl1 pr1 f4 b dn-sssmall greenmod'>{monthString[week[day].getMonth()]}</div>
          <div className='flex pl1 pr1 f4 b greenmod'>{week[day].getDate()}</div>
          <div className='flex b dn-ssmall dn-sssmall greenmod'>{dayOfWeekString[week[day].getDay()]}</div>
        </div>
    } else {
      calenderHeader[day] =
        <div key={day} className={headerClass} style={{ height: CANVAS_HEADER, width: increment.width }}>
          <button
            data-date={week[day]}
            onClick={onClickChangeDay}
            className='other-days pl1 pr1 f4 on flex dn-sssmall items-center navymod'>{week[day].getDate()}
          </button>
          <div className='flex dn-ssmall dn-sssmall items-center navymod'>{dayOfWeekString[week[day].getDay()]}</div>
        </div>
    }

    if (day === targetDay.getDay()) {
      daysOfWeek[day] =
        <Canvas
          key={day}
          day={day}
          date={week[day]}
          jabraNumber={jabraNumber}
          drawingRegion={drawingRegion}
          increment={todayIncrement}
          minutesStyles={todayMinutesStyles}
          clearPreviousRectangle={clearPreviousRectangle}
          selectedMenu={selectedMenu}
          reserveOfDay={reserveOfDays[day]}
        />
    } else {
      daysOfWeek[day] =
        <Canvas
          key={day}
          day={day}
          date={week[day]}
          jabraNumber={jabraNumber}
          drawingRegion={drawingRegion}
          increment={increment}
          minutesStyles={minutesStyles}
          clearPreviousRectangle={clearPreviousRectangle}
          selectedMenu={selectedMenu}
          reserveOfDay={reserveOfDays[day]}
        />
    }
  }

  // FIXME I don't understand make the vertical position middle in inline-block within multiple blocks.
  // In general, we can do that by spcifying height and line-height for parent and vertical-align: middle for children.
  // Instead, I have added 'mt2'.
  return (
    <div className='h-100 pr4 pl4 pb4'>
      <div ref={headerElm} className='fixed flex flex-column justify-center z-5 pt4' style={headerStyle}>
        { dimention.fullWidth > NAVBAR
          && <Box className='dn-small dn-ssmall pv3 ph4' style={{ width: calenderWidth, background: '#F8F8F8' }}>
          <div>
            <div className='flex flex-wrap items-center'>
              <h1 className='times-new-roman fw4 mb2 f3 greenmod'>Reserve a Jabra</h1>
            </div>
            <div className=''>You can reserve a Jabra of a specific number.</div>
            <p className='fw6 mt1 ml3-ns'></p>
          </div>
        </Box> }
        <Box className='flex justify-between items-center ph2 mv2' style={{ width: calenderWidth, height: GOTO_HEIGHT, background: '#69C4CD1A' }}>
          <div className='flex'>
            <div className='dropdown'>
              <button onClick={onClickDropdown} className='dropbtn pa2 mh3 mv1 f6'>Jabra Number</button>
              { open && (<div className='dropdown-content ma0'>
                <ul>
                  {dropDownList}
                </ul>
              </div>)}
              <div className='flex items-center justify-center'>
                <div className='ma1 tc f6 silver'>CURRENT</div><div className='ma1 charcoal'>{jabraNumber}</div>
              </div>
            </div>
            <button onClick={onClickToday} className='mh2' style={{ outline: 'none' }}>
              <ReturnToday className='flex mv2 items-center arrowa' />
              <span className='items-center silver'>Today</span>
            </button>
            <button onClick={onClickPrevious} className='mr1 ml2' style={{ outline: 'none' }}>
              <LeftArrow className='flex items-center arrow' />
            </button>
            <button onClick={onClickNext} className='mr3 ml1' style={{ outline: 'none'}}>
              <RightArrow className='flex items-center arrow' />
            </button>
            <div className='flex flex-column ml3'>
              <div className='charcoal times-new-roman f6'>{accounts[0]}</div>
              <Definition term='ETH' desc={balanceInEth}/>
              { processing > 0 ? <Definition className='blinking' term='State' desc={type} /> : null }
            </div>
          </div>
          { (window.innerWidth >= NAVBAR && processing > 0 && confirmedQueue.length !== 0)
            ? <div className='dn-sssmall flex flex-column justify-center items-center'>
                <div className='lds-dual-ring'></div>
                <div className='dn-sssmall flex mv2 times-new-roman silver blinking'>This will take a few minutes...</div>
              </div>
            : (window.innerWidth < NAVBAR && processing > 0 && confirmedQueue.length !== 0)
              && <div className='lds-dual-ring'></div> }
        </Box>
        <div className='flex justify-center' style={{ background: '#FBFBFB'}} style={{ width: calenderWidth }}>
          <div className='flex'>
            <div className='z-2' style={{ width: TIMEBAR_WIDTH, height: increment.height*2, background: 'white' }}/>
            <div className='z-2 db'>
              <div className='flex z-2'>
                {calenderHeader}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={calenderElm} className='relative z-2 flex justify-center items-center' style={contentsStyle}>
        <TimeBar width={TIMEBAR_WIDTH} height={drawingRegion.height} headerHeight={CANVAS_HEADER} increment={increment.height*2}/>
        <div className='db'>
          <div className='flex z-1'>
            {daysOfWeek}
          </div>
        </div>
      </div>
      {confirmAction}
    </div>
  );
}

const notifyAfterSync = () => {
  return {
    type: ReserveActions.RESERVE_AFTER_SYNC
  }
}

const notifyReserveHeight = navBarVertHeight => {
  return {
    type: ReserveActions.VERTHEIGHT_DETERMINDED,
    navBarVertHeight: navBarVertHeight
  }
}

const mapStateToProps = state => ({
  accounts: state.accounts,
  accountBalances: state.accountBalances,
  type: state.reserve.type,
  added: state.reserve.added,
  synced: state.reserve.synced,
  confirmedQueue: state.reserve.confirmedQueue,
  processing: state.reserve.processing,
  pathnameAtSynced: state.reserve.pathnameAtSynced,
  previousPathname: state.navigation.previousPathname,
  navBarHeight: state.navigation.navBarHeight,
  navBarWidth: state.navigation.navBarWidth
});

export default connect(mapStateToProps)(ReservePage);
